import { AutogenModelSalespersonLookup, AutogenRowSalespersonLookup } from "./autogen/AutogenModelSalespersonLookup";

export class ModelSalespersonLookup extends AutogenModelSalespersonLookup<RowSalespersonLookup> {
    constructor() {
        super(RowSalespersonLookup);
    }
}

export class RowSalespersonLookup extends AutogenRowSalespersonLookup {
}